export default "/assets/images/app-update-img-03.webp?b9b0ea463d4fceee26df93cf04bee342";